export default __webpack_public_path__ + "static/media/Landau & Assoc.4df7a849.jpg";